import { Col } from 'components/Col';
import { CustomButton } from 'components/CustomButton';
import ArrowBackIcon from 'components/Icons/ArrowBackIcon';
import ArrowForwardIcon from 'components/Icons/ArrowForwardIcon';
import HistoryRoundedIcon from 'components/Icons/HistoryRoundedIcon';
import RefreshIcon from 'components/Icons/RefreshIcon';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import CienciaCoordenadorPedagogico from 'pages/FluxoProjetos/Conteudo/campos/cienciaCoordenadorPedagogico';
import ConsultaPublica from 'pages/FluxoProjetos/Conteudo/campos/consultaPublica';
import DireitoImagem from 'pages/FluxoProjetos/Conteudo/campos/direitoImagem';
import { Fragment, useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/modules/ModalActions';
import languageValues from 'utils/LanguageUtils';
import { getUniqueKey } from 'utils/NumberUtils';
import { etapasConfig } from 'utils/projeto';
import HistoricoModal from '../historicoModal/historicoModal';
import styles from './footerEtapa.scss';
const { rootClassName } = styles;

export default function FooterEtapa(props: { etapa: EtapaProjeto }) {
  const { state, validator, changeEtapa, saveEtapa } =
    useContext(ProjetosContext);
  const d = useDispatch();

  const indexAtual = useMemo(
    () => Object.values(EtapaProjeto).indexOf(props.etapa),
    [props.etapa]
  );

  const nextEtapa = useMemo(() => {
    if (indexAtual >= Object.values(EtapaProjeto).length) {
      return undefined;
    }
    return Object.values(EtapaProjeto)[indexAtual + 1];
  }, [indexAtual]);

  const prevEtapa = useMemo(() => {
    if (indexAtual === 0) {
      return undefined;
    }
    return Object.values(EtapaProjeto)[indexAtual - 1];
  }, [indexAtual]);

  const handleChange = useCallback(
    (change: -1 | 1) => {
      if (change > 0 && nextEtapa) {
        saveEtapa(nextEtapa);
      } else if (prevEtapa) {
        changeEtapa(prevEtapa);
      }
    },
    [changeEtapa, nextEtapa, prevEtapa, saveEtapa]
  );

  const backButton = useMemo(() => {
    return Object.values(EtapaProjeto).indexOf(props.etapa) > 0 ? (
      <CustomButton
        className={`${rootClassName}-prev`}
        label={languageValues.actions.anterior}
        theme='pufvYellow'
        disabled={!validator?.etapaIsCompleted[EtapaProjeto.infosIniciais]}
        onClick={() => {
          handleChange(-1);
        }}
        leftIcon={<ArrowBackIcon />}
      />
    ) : (
      <Fragment />
    );
  }, [handleChange, props.etapa, validator?.etapaIsCompleted]);

  const nextButton = useMemo(() => {
    return Object.values(EtapaProjeto).indexOf(props.etapa) <
      Object.values(EtapaProjeto).length - 1 ? (
      <CustomButton
        className={`${rootClassName}-next`}
        label={
          state.disabledFields
            ? languageValues.actions.proxima
            : languageValues.actions.concluirAvancar
        }
        theme='pufvYellow'
        onClick={() => handleChange(1)}
        rightIcon={
          Object.values(state.etapasLoading).some((e) => Boolean(e)) ? (
            <RefreshIcon currentColor='black' />
          ) : (
            <ArrowForwardIcon />
          )
        }
        disabled={
          (state.sent && !validator?.etapaIsCompleted[props.etapa]) ||
          Object.values(state.etapasLoading).some((e) => Boolean(e))
        }
      />
    ) : (
      <Fragment />
    );
  }, [
    handleChange,
    props.etapa,
    state.disabledFields,
    state.etapasLoading,
    state.sent,
    validator?.etapaIsCompleted,
  ]);

  const reviewButton = useMemo(() => {
    const revisao = state.statusEtapas[props.etapa];

    return etapasConfig[props.etapa].showReviewButton ? (
      <Col className={`${rootClassName}-review`}>
        <CustomButton
          theme='warning'
          label={languageValues.buttons.review}
          leftIcon={<HistoryRoundedIcon />}
          counter={revisao ? revisao?.historico?.length : undefined}
          disabled={!revisao || (revisao?.historico?.length === 0 ?? true)}
          onClick={() => {
            const modalKey = getUniqueKey();
            d(
              openModal(HistoricoModal, {
                etapa: props.etapa,
                historico: revisao!,
                modalKey,
                flgInfantil: state.projeto.flgInfantil ?? false,
              })
            );
          }}
        />
      </Col>
    ) : (
      <Fragment />
    );
  }, [d, props.etapa, state.projeto.flgInfantil, state.statusEtapas]);

  const consulta = useMemo(() => {
    return etapasConfig[props.etapa].showConsultaPublica ? (
      <ConsultaPublica />
    ) : (
      <Fragment />
    );
  }, [props.etapa]);

  const imagem = useMemo(() => {
    return etapasConfig[props.etapa].showDireitoImagem ? (
      <DireitoImagem />
    ) : (
      <Fragment />
    );
  }, [props.etapa]);

  const cienciaCoordenador = useMemo(() => {
    return etapasConfig[props.etapa].showCienciaCoordenador ? (
      <CienciaCoordenadorPedagogico />
    ) : (
      <Fragment />
    );
  }, [props.etapa]);

  return (
    <Fragment>
      <hr />
      {cienciaCoordenador}
      {imagem}
      {consulta}
      <Row>
        <Col className={rootClassName}>
          {backButton}
          {nextButton}
        </Col>
        {reviewButton}
      </Row>
    </Fragment>
  );
}
